import { isUndefined } from 'lodash-es';
import { useContext } from 'react';

import { XYChartAnnotationsHiddenTracksContext } from '../context/XYChartAnnotationsHiddenTracks.context.js';

export const useXYChartAnnotationsHiddenTracks = () => {
  const context = useContext(XYChartAnnotationsHiddenTracksContext);
  if (isUndefined(context)) {
    throw new Error(
      'useXYChartAnnotationsHiddenTracks must be used within a XYChartAnnotationsHiddenTracksContext.Provider',
    );
  }

  return context;
};
